// store/modules/routes.js
const state = {
  showMainContent: true
};

const mutations = {
  setShowMainContent(state, show) {
    state.showMainContent = show;
  }
};

const actions = {
  toggleMainContent({ commit }, show) {
    commit('setShowMainContent', show);
  }
};

const getters = {
  showMainContent: (state) => state.showMainContent
};

export default {
  state,
  mutations,
  actions,
  getters
};
